class ContentScrollItem extends HTMLElement {
  constructor() {
    super();

    const scroller_media_items = this.closest(".content-scroll").querySelectorAll(".content-scroll-media-item");

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const third_of_viewport = window.innerHeight / 3;

        const top_enters = (entry.boundingClientRect.top < third_of_viewport && entry.boundingClientRect.top > 0);

        const bottom_enters = (entry.boundingClientRect.bottom > third_of_viewport && entry.boundingClientRect.bottom < window.innerHeight);

        if (entry.isIntersecting && (top_enters || bottom_enters)) {
          scroller_media_items.forEach((element) => {
            element.classList.remove("state--active");
          });

          scroller_media_items[this.dataset.index].classList.add("state--active");
        }
      });
    }, {
      threshold: [0, 0.25, 0.5, 0.75, 1]
    });

    observer.observe(this);
  }
}

customElements.define("content-scroll-item", ContentScrollItem);

class ContentScroll extends HTMLElement {
  constructor() {
    super();

    const id = this.getAttribute("id");

    const slider = new Flickity(this, {
      imagesLoaded: true,
      contain: true,
      prevNextButtons: false,
      pageDots: true,
      loop: true,
      fade: true
    });

    document.addEventListener("contentscrollmedia:" + id + ":change", (event) => {
      slider.select(event.detail.index);
    });

    slider.on("change", (index) => {
      document.dispatchEvent(new CustomEvent("contentscroll:" + id + ":change", {
        detail: {
          index: index
        }
      }));
    });
  }
}

customElements.define("content-scroll", ContentScroll);

class ContentScrollMedia extends HTMLElement {
  constructor() {
    super();

    const id = this.getAttribute("id");

    let options = {
      imagesLoaded: true,
      draggable: false,
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      loop: true,
      fade: true
    };

    if (matchMedia("(max-width: 767px)").matches) {
      options.draggable = true;
      options.dragThreshold = 10;
    }

    const slider = new Flickity(this, options);

    document.addEventListener("contentscroll:" + id + ":change", (event) => {
      slider.select(event.detail.index);
    });

    slider.on("change", (index) => {
      const inactive_video_elements = this.querySelectorAll(".flickity-slider > div:not(.is-selected) video-inline");

      inactive_video_elements.forEach((video) => {
        video.stop();
      });

      document.dispatchEvent(new CustomEvent("contentscrollmedia:" + id + ":change", {
        detail: {
          index: index
        }
      }));
    });
  }
}

customElements.define("content-scroll-media", ContentScrollMedia);
